import Api from '@/services/Api'

export default {
  getTags(params) {
    return Api().get(`bleTags`, { params })
  },
}
